import gql from 'graphql-tag';
import { CartMainFragment } from '../fragments/cartFragment.mainEndpoint';

const DeliveryIntervalFragment = gql`
  fragment DeliveryIntervalFragment on DataFlexibleDeliveryIntervalsUnion {
    canChangeRange
    recommendedTime {
      time
      price
    }
    intervals {
      id
      date
      end
      price
      start
      title
      minWidth
      maxStart
      selectedEnd
      selectedStart
      selectedWidth
    }
  }
`;

const NotAvaliableCatalogsWithAmountFragment = gql`
  fragment NotAvaliableCatalogsWithAmountFragment on DataFlexibleDeliveryIntervalsUnion {
    notAvaliableCatalogsWithAmount {
      cartItem {
        id
        product {
          id
          title
          price
          oldPrice
          maxPurchase
          mainImage
          weightOfGoods
          isPostponed
          mainRootRubric {
            id
            title
            shortTitle
            short_title
            identify
          }
          nearestDelivery {
            value
          }
          isAvailableForPurchase

          comments_number
          rating_comments
          war_id

          catalogAnalogs {
            id
            title
            oldPriceField
            currentPriceField
            mainImage

            oldPriceField2
            currentPriceField2

            comments_number
            rating_comments
            weight_of_goods
            war_id

            measureItem {
              weight
              symbol
            }

            priceBlockWeightPrice
            vesovoi
          }
        }
        amount
        purchasePrice
        discount
        freeOfCharge
      }
      error
      maxAllowedQuantity
      maxAllowedQuantityOnDate
      multiPriceAmount
      multiPriceSum
      date
    }
  }
`;

const ProductFragment = gql`
  fragment ProductFragment on CartItemsModel {
    product {
      id
      title
      mainImage
      price
      oldPrice

      catalogAnalogs {
        id
        title
        oldPriceField
        currentPriceField
        mainImage

        oldPriceField2
        currentPriceField2

        comments_number
        rating_comments
        weight_of_goods

        measureItem {
          weight
          symbol
        }

        priceBlockWeightPrice
        vesovoi
      }
    }
  }
`;

export const OrderFragment = gql`
  fragment OrderFragment on OrdersModel {
    id
    deliveryDate
    deliveryIntervalTitle
    peopleAddress {
      id
      title
    }
    price
    email
    dadata {
      id
      geoLat
      geoLon
      cityType
      city
      settlementType
      settlement
      streetType
      street
      houseType
      house
      blockType
      block
    }
    payment {
      id
    }
    secretKey
    totalWithDeliveryPrice
    phone
    fio
  }
`;

const CartQL = {
  getAmountStores: gql`
    query getAmountStores {
      getAmountStores {
        id
        is_delivery
        type
        name
        parking
        address
        is_mobile
        point
        description
        nearestAvailableInterval {
          value
          nearestIntervalTitle
          assemblyTime
        }

        paymentTypes {
          id
          title
        }
        scheduleItems {
          day
          start_time
          end_time
          max_time
          status
        }

        attachmentsItems {
          attachmentsItem {
            tempFullFilePath
          }
        }
        deliveryIntervals {
          value
          storeId
          available
          intervals {
            id
            title
            date
            start
            end

            interval_start_minutes
            interval_end_minutes
          }
          notAvailableProducts {
            id
            ...ProductFragment
            amount
            multiPriceAmount
          }
          notAvaliableLoyaltyProducts {
            id
            title
            mainImage
          }
          notAvailableGifts {
            mainImage
          }
        }
      }
    }
    ${ProductFragment}
  `,
  pickupPointById: gql`
    query pickupPointById(
      $cartToken: String!
      $storeId: Int!
      $imageFilter: ImgeFilterE
    ) {
      pickupPointById(
        cartToken: $cartToken
        storeId: $storeId
        imageFilter: $imageFilter
      ) {
        id
        city_id
        type
        has_amount
        name
        address
        parking
        is_mobile
        point
        description
        min_order_price
        nearestAvailableInterval {
          value
        }
        paymentTypes {
          id
          title
        }
        shop {
          id
          type
          metroStations {
            id
            title
            line {
              id
              title
              color
            }
          }
        }
        attachmentsItems {
          attachmentsItem {
            tempFullFilePath
          }
        }
        scheduleItems {
          day
          start_time
          end_time
          max_time
          status
        }
        deliveryIntervals {
          value
          storeId
          available
          intervals {
            id
            title
            date
            start
            end

            interval_start_minutes
            interval_end_minutes
          }
          notAvailableProducts {
            id
            ...ProductFragment
            amount
            multiPriceAmount
          }
          notAvaliableServices {
            id
            service {
              id
              title
              multiple
              shortDescription
              priceWithSubscription
              subscriptionPeriod
              subscription_period
              price
              maxQuantityInOrder
            }
            subscription
            amount
            price
            total
          }
          notAvaliableLoyaltyProducts {
            id
            title
            mainImage
          }
          notAvailableGifts {
            mainImage
          }

          ...NotAvaliableCatalogsWithAmountFragment
        }
      }
    }
    ${ProductFragment}
    ${NotAvaliableCatalogsWithAmountFragment}
  `,
  deliveryAddresses: gql`
    query deliveryAddresses($cartToken: String!, $imageFilter: ImgeFilterE) {
      deliveryAddresses(cartToken: $cartToken, imageFilter: $imageFilter) {
        id
        type
        name
        parking
        address
        is_mobile
        point
        description
        min_order_price
      }
    }
  `,
  pickupPoints: gql`
    query pickupPoints($cartToken: String!, $imageFilter: ImgeFilterE) {
      pickupPoints(cartToken: $cartToken, imageFilter: $imageFilter) {
        id
        city_id
        type
        name
        parking
        address
        is_mobile
        point
        description
        min_order_price
        nearestAvailableInterval {
          value
        }
        paymentTypes {
          id
          title
        }
        has_amount
        shop {
          id
          type
          metroStations {
            id
            title
            line {
              id
              title
              color
            }
          }
        }

        scheduleItems {
          day
          start_time
          end_time
          max_time
          status
        }
        attachmentsItems {
          attachmentsItem {
            tempFullFilePath
          }
        }
      }
    }
  `,
  nearestDelivery: gql`
    query nearestDelivery($cartToken: String!) {
      nearestDelivery(cartToken: $cartToken) {
        date
        interval
        time
        title
        titleFull
        month
        dom
        price
        min_price
        type
      }
    }
  `,

  getDeliveryIntervals: gql`
    query getDeliveryIntervals(
      $cartToken: String!
      $coordinates: CoordinatesInput!
      $range: [DeliveryIntervalInput!]
    ) {
      getDeliveryIntervals(
        cartToken: $cartToken
        coordinates: $coordinates
        range: $range
      ) {
        intervals {
          value
          storeId
          available
          ...DeliveryIntervalFragment
          notAvailableProducts {
            id
            ...ProductFragment
            amount
            multiPriceAmount
          }
          notAvaliableServices {
            id
            service {
              id
              title
              multiple
              shortDescription
              priceWithSubscription
              subscriptionPeriod
              subscription_period
              price
              maxQuantityInOrder
            }
            subscription
            amount
            price
            total
          }
          notAvailableGifts {
            id
            mainImage
          }
          notAvaliableLoyaltyProducts {
            id
            title
            mainImage
          }
          ...NotAvaliableCatalogsWithAmountFragment
        }

        express {
          value
          storeId
          available
          ...DeliveryIntervalFragment
          notAvailableProducts {
            id
            ...ProductFragment
            amount
            multiPriceAmount
          }
          notAvaliableServices {
            id
            service {
              id
              title
              multiple
              shortDescription
              priceWithSubscription
              subscriptionPeriod
              subscription_period
              price
              maxQuantityInOrder
            }
            subscription
            amount
            price
            total
          }
          notAvailableGifts {
            id
            mainImage
          }
          ...NotAvaliableCatalogsWithAmountFragment
        }
      }
    }
    ${NotAvaliableCatalogsWithAmountFragment}
    ${DeliveryIntervalFragment}
    ${ProductFragment}
  `,

  deliveryIntervals: gql`
    query flexibleDeliveryIntervals(
      $cartToken: String!
      $coordinates: CoordinatesInput!
      $range: [DeliveryIntervalInput!]
    ) {
      cart(cartToken: $cartToken) {
        id
        cookieId
      }

      flexibleDeliveryIntervals(
        cartToken: $cartToken
        coordinates: $coordinates
        range: $range
      ) {
        value
        storeId
        available
        ...DeliveryIntervalFragment
        notAvailableProducts {
          id
          ...ProductFragment
          amount
          multiPriceAmount
        }
        notAvaliableServices {
          id
          service {
            id
            title
            multiple
            shortDescription
            priceWithSubscription
            subscriptionPeriod
            subscription_period
            price
            maxQuantityInOrder
          }
          subscription
          amount
          price
          total
        }

        ...NotAvaliableCatalogsWithAmountFragment

        notAvailableGifts {
          id
          mainImage
        }
        notAvaliableLoyaltyProducts {
          id
          title
          mainImage
        }
      }
    }
    ${NotAvaliableCatalogsWithAmountFragment}
    ${DeliveryIntervalFragment}
    ${ProductFragment}
  `,
  createOrderFromCart: gql`
    mutation createOrderFromCart(
      $cartToken: String!
      $data: SaveOrderInput!
      $isDuplicateRequest: Boolean
    ) {
      createOrderFromCart(
        cartToken: $cartToken
        cartData: $data
        isDuplicateRequest: $isDuplicateRequest
      ) {
        success
        error
        errorCode
        order {
          secretKey
          ...OrderFragment
        }
      }
    }
    ${OrderFragment}
  `,
  afterOrderPromocode: gql`
    query afterOrderPromocode(
      $orderId: Float!
      $secretKey: String!
      $code: String
    ) {
      afterOrderPromocode(
        orderId: $orderId
        secretKey: $secretKey
        code: $code
      ) {
        success
        info
        code
        endDate
        value
        title
        text
        image
        typeId
      }
    }
  `,
  getPaymentOptions: gql`
    query getPaymentOptions(
      $store_id: Int
      $digital: Boolean
      $cartToken: String
      $productId: Int
    ) {
      paymentOptions(
        store_id: $store_id
        digital: $digital
        cartToken: $cartToken
        productId: $productId
      ) {
        id
        title
        identify
        minPrice
        maxPrice
        bonus_percent
        possibleExtraBonus
      }
    }
  `,
  updateCart: gql`
    mutation updateCart($cartToken: String!, $data: UpdateCartInput!) {
      updateCart(cartToken: $cartToken, cartData: $data) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  todayLatestInterval: gql`
    query todayLatestInterval($cartToken: String!) {
      todayLatestInterval(cartToken: $cartToken) {
        value
        willBeClosed
        interval
        price
        minPrice
      }
    }
  `,
  addItemsToCartFromOrder: gql`
    mutation addItemsToCartFromOrder(
      $cartToken: String!
      $orderId: Int!
      $latest: Boolean!
    ) {
      addItemsToCartFromOrder(
        cartToken: $cartToken
        orderId: $orderId
        latest: $latest
      ) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  addItemsToCartFromTemplate: gql`
    mutation addItemsToCartFromTemplate($cartToken: String!, $id: Int!) {
      addItemsToCartFromTemplate(cartToken: $cartToken, id: $id) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  createCartFromOrder: gql`
    mutation createCartFromOrder($orderId: Int!) {
      createCartFromOrder(orderId: $orderId) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  saveChangesToOrder: gql`
    mutation saveChangesToOrder(
      $cartToken: String!
      $orderId: Int!
      $cartData: SaveOrderInput!
      $editV2: Boolean
    ) {
      saveChangesToOrder(
        orderId: $orderId
        cartToken: $cartToken
        cartData: $cartData
        editV2: $editV2
      ) {
        success
        error
        errorCode
        order {
          ...OrderFragment
        }
      }
    }
    ${OrderFragment}
  `,
  undoChangesToOrder: gql`
    mutation undoChangesToOrder($cartToken: String!, $orderId: Int!) {
      undoChangesToOrder(orderId: $orderId, cartToken: $cartToken) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  cancelOrder: gql`
    mutation cancelOrder(
      $orderId: Int!
      $reasonId: Int
      $cancelComment: String
    ) {
      cancelOrder(
        orderId: $orderId
        reasonId: $reasonId
        cancelComment: $cancelComment
      ) {
        success
        error
        order {
          ...OrderFragment
        }
      }
    }
    ${OrderFragment}
  `,
  mergeCarts: gql`
    mutation mergeCarts(
      $sourceCartToken: String!
      $targetCartToken: String!
      $sourceCartItemId: Int
      $registration: Boolean
    ) {
      mergeCarts(
        sourceCartToken: $sourceCartToken
        targetCartToken: $targetCartToken
        sourceCartItemId: $sourceCartItemId
        registration: $registration
      ) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  updateCartLoyaltyProgram: gql`
    mutation updateCartLoyaltyProgram(
      $cartToken: String!
      $cartLoyaltyProgramId: Int!
      $productId: Int
      $serviceId: Int
      $quantity: Int
    ) {
      updateCartLoyaltyProgram(
        cartToken: $cartToken
        cartLoyaltyProgramId: $cartLoyaltyProgramId
        productId: $productId
        serviceId: $serviceId
        quantity: $quantity
      ) {
        success
        error
        cart {
          ...CartMainFragment
        }
      }
    }
    ${CartMainFragment}
  `,
  configValue: gql`
    query configValue($name: String!) {
      configValue(name: $name) {
        value
      }
    }
  `,
  confirmProfileBySMS: gql`
    mutation confirmProfileBySMS(
      $cartToken: String!
      $action: PeopleSmsAction!
      $phone: String
      $code: Int
    ) {
      confirmProfileBySMS(
        cartToken: $cartToken
        action: $action
        phone: $phone
        code: $code
      ) {
        success
        error
      }
    }
  `,
  checkMaxAvailableQuantityInOneOrder: gql`
    query checkMaxAvailableQuantityInOneOrder(
      $cartToken: String!
      $date: DateTime!
    ) {
      checkMaxAvailableQuantityInOneOrder(cartToken: $cartToken, date: $date) {
        cartItem {
          id
          product {
            id
            title
            price
            oldPrice
            maxPurchase
            mainImage
            weightOfGoods
            mainRootRubric {
              id
              title
              shortTitle
              short_title
              identify
            }
            nearestDelivery {
              value
            }
            isAvailableForPurchase
          }
          amount
          purchasePrice
          discount
          freeOfCharge
        }
        date
        maxAllowedQuantity
        error
      }
    }
  `,
  checkCartChanges: gql`
    query checkCartChanges($cartToken: String!) {
      checkCartChanges(cartToken: $cartToken) {
        priceChanges {
          product {
            id
            title
            vesovoi
          }
          oldPrice
          price
          dateTime
        }
        statusChanges {
          id
          cartItemId
          title
        }
        notAvailablePromoCodes {
          id
          isTypeWithGift
          gift {
            id
            title
          }
        }
        possibleAutoPromoCodes {
          id
          isTypeWithGift
          gift {
            id
            title
            isAvailableForPurchase
          }
        }
        possibleAutoServices {
          id
          title
        }
        globalGift {
          id
          cartItemId
          title
        }
      }
    }
  `,
  isPersonRestrincted: gql`
    query isPersonRestrincted {
      isPersonRestrincted
    }
  `
};

export default CartQL;
